import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { updateNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getUpdateNumber } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "created_at", "last_updated"];

const TmobilejUpdateNumberBatch = () => (
  <BatchDetail
    title="Update Number"
    apiGet={__getUpdateNumber}
    client={CLIENTS.tmobilej}
    columnsFactory={updateNumberColumns}
    copyKeys={COPY_KEYS}
    exportAction="update_number"
    retryOperation="update_number"
    showTerminate
    getRowPath={(row) => `/tmobilej/update_number/${row.id}`}
  />
);

export default TmobilejUpdateNumberBatch;
